import styled from 'styled-components';
import {leftEaseIn, animateStripes} from '../../styles/keyframes/keyframes';

export const ProgressBarStyled = styled.div`
  width: 100%;
  border-radius: 0.5rem;
  background-color: ${props => props.theme.progressBar.backgroundColor};
  height: 1rem;
  position: relative;
  background-size: 30px 30px;
  background-image: ${props => props.active ?
    'linear-gradient(135deg, rgba(255, 255, 255, .5) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .5) 50%, rgba(255, 255, 255, .5) 75%, transparent 75%, transparent)' : 'none'};
  animation: ${animateStripes} 3s linear infinite;
`;

export const Bar = styled.div`
  display: inline-block;
  width: ${props => props.processing};
  background-color: ${props => props.finished ? props.theme.progressBar.color : 'none'};
  border-radius: 0.5rem;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  animation-timing-function: linear;
  animation-name: ${leftEaseIn};
  animation-duration: ${props => props.duration};
`;

export const Stripes = styled.span`
  display: block;
  height: 100%;
  width: 100%;
  background-size: 20px 20px;
  background-image: ${props => props.active ?
    'linear-gradient(135deg, rgba(255, 195, 163, 0.3) 25%, transparent 25%, transparent 50%, rgba(255, 195, 163, 0.3) 50%, rgba(255, 195, 163, 0.3) 75%, transparent 75%, transparent)' : 'none'};
  animation: ${animateStripes} linear infinite;
  animation-duration: ${props => props.completed ? 0 : '2s'};
`;



// WEBPACK FOOTER //
// ./components/ProgressBar/ProgressBar.style.js